<template>
    <div
        v-bind="$attrs"
        class="ds-multiselect-option flex w-full min-w-0 items-start justify-between rounded-lg p-3"
        :class="[
            disabled
                ? 'cursor-not-allowed text-content-disabled'
                : 'cursor-pointer bg-semantic-secondary-default hover:bg-semantic-secondary-hover active:bg-semantic-secondary-pressed',
        ]"
        @click.stop="!disabled && $emit('click', $event)"
    >
        <div class="relative flex min-w-0 flex-1 items-start gap-2 break-all">
            <slot name="leading" />
        </div>

        <slot
            class="flex-shrink-0"
            name="trailing"
        />
    </div>
</template>

<script setup lang="ts">
import { type DsMultiSelectOptionProps } from '@/components/design-system/multiselect/multi-select.types';

defineProps<DsMultiSelectOptionProps>();

defineEmits<{
    (e: 'click', event: MouseEvent): void;
}>();
</script>
